import { fontStyles } from 'styles/theme';
import styled from '@emotion/styled';

export default styled.span({
  fontSize: fontStyles.sizes.xs,
  color: fontStyles.colors.tertiary,
  lineHeight: '16px',
});
